import React, {Component} from 'react'
import {Col, Container, Row} from 'react-bootstrap'

export default class Skills extends Component {
    render() {
        return (
            <Container className="py-4">
                <Row className="mt-5">
                    <Col lg={6} className="text-light">
                        <h2 >Personal Info</h2>
                        <Row>
                            <Col md={5}>
                                <p>Name: mehedi</p>
                                <p>Phone: 0124596</p>
                                <p>City: Bangladesh</p>
                            </Col>
                            <Col md={5}>
                                <p>Age: 22</p>
                                <p>Freelance : Available</p>
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={6}>
                        <Row>
                            <Col Col md={5} style={{backgroundColor: '#6f97f7', borderRadius: '10px'}} className="py-4 m-3 text-light">
                                <h2>753</h2>
                                <h4>Get Award</h4>
                            </Col>
                            <Col md={5} style={{backgroundColor: '#fbdd62', borderRadius: '10px'}} className="py-4 m-3 text-light">
                                <h2>250</h2>
                                <h4>Project Done</h4>
                            </Col>
                            <Col md={5} style={{backgroundColor: '#ff4274', borderRadius: '10px'}} className="py-4 m-3 text-light">
                                <h2>523</h2>
                                <h4>Happy Client</h4>
                            </Col>
                            <Col md={5} style={{backgroundColor: '#6f97f7', borderRadius: '10px'}} className="py-4 m-3 text-light">
                                <h2>600</h2>
                                <h4>Files Download</h4>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        )
    }
}
